/* ==========================================================================
   MPanelSearcherRxjs > Client > loading
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addData, addStyle } = require('@bluekiri/alexandria/helpers/dataHelpers');

const LoadingTemplate = require('@bluekiri/alexandria-contrib-components/components/loading-information-rxjs/template'); //eslint-disable-line
const Loading = require('@bluekiri/alexandria-contrib-components/components/loading-information-rxjs/client/js'); //eslint-disable-line

const configuration = require('../config');

/* Create loading */
function createLoading(instance) {
    /* Data */
    const { literals = {}, context, loadingImage } = instance.config;

    /* Template */
    const template = LoadingTemplate(
        addStyle(
            addData(
                {
                    image: {
                        config: {
                            isLazy: false
                        },
                        src: loadingImage
                    },
                    title: literals.loadingTitle,
                    description: loadingtext(instance),
                    message: literals.loadingMessage
                },
                {
                    type: configuration().type.loading
                }
            ),
            [configuration().css.loading]
        ),
        context
    );

    /* Return Node */
    return toNode(template)[0];
}

function loadingtext(instance) {
    const { origin, destination, calendarInput, accommodationInput, vehicleInput } = instance;

    if (!origin || !destination || !calendarInput || !accommodationInput || !vehicleInput) return '';

    /* store */
    const { value: originTxt } = origin.input.store.select('input');
    const { value: destinationTxt } = destination.input.store.select('input');
    const { value: dateTxt } = calendarInput.input.store.select('input');
    const { value: accommodationTxt } = accommodationInput.input.store.select('input');
    const { value: vehicleTxt } = vehicleInput.input.store.select('input');

    /* -Template */

    return html(`
        <p>${originTxt} - ${destinationTxt}</p>
        <p>${dateTxt}</p>
        <p>${accommodationTxt}</p>
        <p>${vehicleTxt}</p>`);
}

/* Init Loading */
function initLoading(instance) {
    const inst = instance;

    /* Modal bolena controler */
    const { showLoading = true } = instance.config;

    if (!showLoading) return '';

    /* Node */
    const node = createLoading(instance);

    /* Add to DOM */
    document.body.appendChild(node);

    /* MLoadingRxjs */
    inst.loading = Loading(`[data-component="LoadingInformationRxjs"][data-type="${configuration().type.loading}"]`);

    /* Return */
    return inst;
}

/* Destroy loading */
function destroyLoading(instance) {
    const inst = instance;

    /* Remove from DOM */
    inst.loading.actions.destroy();
    delete inst.loading;
}

/* Export */
module.exports = {
    initLoading,
    destroyLoading
};
